module.exports = __webpack_public_path__ + "img/orangeQunfa.93f15c95.png";